import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContactFormService } from '../../../services/contact-form.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {
  formSent = false;
  constructor(private formService: ContactFormService) {}

  scrollRouting($element) {
    // console.log($element);
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }


  submitForm(form: NgForm) {
    if(form.invalid) {
      return;
    }
    this.formService.sendForm(
    form.value.name,
    form.value.phone,
    form.value.email,
    form.value.ask_a_question,
    form.value.meet_with_broker,
    form.value.contact_agent,
    form.value.calculate_mortgage,
    form.value.calculate_titlecost,
    form.value.schedule_a_meeting,
    form.value.virtual_tour,
    form.value.join_stride,
    form.value.something_else,
    form.value.state,
    form.value.message,
    form.value.source,
    );
    this.formSent = true;
    form.reset();
  }
}
